module.exports = __webpack_public_path__ + "static/media/Dacia-Duster-side-1.eb284234.jpg";